import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { DataListParams, DataListProp, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import {
  runFormFunction,
  calSubListFieldsTotal,
  setSubListFieldOrder,
  runSubListCommand,
  getMatchingData,
  getFormMemo,
  convertSubListToFormDataDetail,
  convertFormValues,
} from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { DataCols, DataColumn, DataColumnField, DataColumnRecord } from "../../input/inputType";
import { getFormValues, setFormValues } from "../defaultTypeCheck";
import { checkEmpty, getJsonFromStr, getStrFromJson } from "@/util/stringutil";
import { Flex } from "@radix-ui/themes";
import { fetchHost, fetchUtil } from "@/util/fetchutil";
import { getIntArray } from "@/util/arrayutil";
import { enLocale } from "@/i18n/routing";
import { coffeebeanBestDate } from "../../inputCols/brewingCols";
import { listEditClickCommon } from "../../data/list/list";
export const BlendingResult = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;
  // const roastingFormName = "form.ant-form#RoastingResultData_Form";

  const utcOffset = dayjs().utcOffset() * 60000;
  const roasting_comb_hidden = " hidden";
  const roasting_fields = ["roasting_seq", "roasting_mass", "roasting_percent"];
  const roasting_result_fields = [
    "roasting_seq",
    "roasting_result_seq",
    "roasting_mass",
    "roasting_percent",
    "roasting_loss",
    "roasting_organic_loss",
  ];
  const setRoastingProfileUse = (values?: any, force?: boolean) => {
    Debug("setRoastingProfileUse", values);
    const roasting_profile_use =
      force !== undefined
        ? force
        : form?.current?.getFieldInstance("roasting_profile_use")
          ? form.current.getFieldValue("roasting_profile_use")
          : values !== undefined
            ? values["roasting_profile_use"]
            : undefined;
    //const formObj = document.querySelector(roastingFormName) as HTMLFormElement;
    if (roasting_profile_use !== undefined) {
      if (roasting_profile_use) {
        if (dataFunction?.current && dataFunction.current["addFormClass"]) {
          dataFunction.current["addFormClass"]("roasting_profile_use");
        }
      } else {
        if (dataFunction?.current && dataFunction.current["removeFormClass"]) {
          dataFunction.current["removeFormClass"]("roasting_profile_use");
        }
      }
    }
  };
  const seqSelectWithList: string[] = [];
  const resultSelectWithList: string[] = [];
  for (let i = 0; i < 20; i++) {
    seqSelectWithList.push("roasting_seq_" + i);
    resultSelectWithList.push("roasting_result_seq_" + i);
  }
  const setRoastingOrder = () => {
    setTimeout(() => {
      if (form?.current && formFunction?.current) {
        setSubListFieldOrder(form.current, formFunction.current, "roasting_comb", "roasting_order");
      }
    }, 150);
  };

  const calRoastingMass = (calcLoss?: boolean) => {
    if (form?.current && formFunction?.current) {
      calSubListFieldsTotal(
        form.current,
        formFunction.current,
        "roasting_comb",
        "blending_total_mass",
        "roasting_mass",
        "roasting_percent", //"label", //"roasting_greenbean_percent",
        { blending_loss: "roasting_loss", blending_organic_loss: "roasting_organic_loss" },
      );
    }
  };
  const setRoastingInfo = () => {
    if (form?.current && formFunction?.current) {
      const { run, result } = runFormFunction(formFunction.current, "roasting_comb", "getCount");
      const set_values: Record<string, any> = {};

      const blending_country_list: string[] = [];
      const blending_variety_list: string[] = [];
      const blending_grade_list: string[] = [];
      const blending_grade_detail_list: string[] = [];
      const blending_process_list: string[] = [];
      const blending_variety_etc_list: string[] = [];
      const blending_process_etc_list: string[] = [];

      getIntArray(result, 0, (i) => {
        const temp_result = runFormFunction(formFunction?.current, "roasting_result_seq_" + i, "selectData");
        const temp_data = temp_result.result;
        if (temp_data) {
          const temp_greenbean_country_list = temp_data["greenbean_country_list"];
          const temp_greenbean_variety_list = temp_data["greenbean_variety_list"];
          const temp_greenbean_grade = temp_data["greenbean_grade_list"];
          const temp_greenbean_grade_detail = temp_data["greenbean_grade_detail_list"];
          const temp_greenbean_process = temp_data["greenbean_process_list"];
          const temp_greenbean_variety_etc = temp_data["greenbean_variety_etc"];
          const temp_greenbean_process_etc = temp_data["greenbean_process_etc"];

          if (!checkEmpty(temp_greenbean_country_list) && typeof temp_greenbean_country_list === "string") {
            const temp_arr = temp_greenbean_country_list.split(",");
            temp_arr.forEach((temp) => {
              if (!blending_country_list.includes(temp)) {
                blending_country_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_variety_list) && typeof temp_greenbean_variety_list === "string") {
            const temp_arr = temp_greenbean_variety_list.split(",");
            temp_arr.forEach((temp) => {
              if (!blending_variety_list.includes(temp)) {
                blending_variety_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_grade) && typeof temp_greenbean_grade === "string") {
            const temp_arr = temp_greenbean_grade.split(",");
            temp_arr.forEach((temp) => {
              if (!blending_grade_list.includes(temp)) {
                blending_grade_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_grade_detail) && typeof temp_greenbean_grade_detail === "string") {
            const temp_arr = temp_greenbean_grade_detail.split(",");
            temp_arr.forEach((temp) => {
              if (!blending_grade_detail_list.includes(temp)) {
                blending_grade_detail_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_process) && typeof temp_greenbean_process === "string") {
            const temp_arr = temp_greenbean_process.split(",");
            temp_arr.forEach((temp) => {
              if (!blending_process_list.includes(temp)) {
                blending_process_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_variety_etc) && !blending_variety_etc_list.includes(temp_greenbean_variety_etc)) {
            blending_variety_etc_list.push(temp_greenbean_variety_etc);
          }
          if (!checkEmpty(temp_greenbean_process_etc) && !blending_process_etc_list.includes(temp_greenbean_process_etc)) {
            blending_process_etc_list.push(temp_greenbean_process_etc);
          }

          // Debug(i, temp_result.result);
        }
      });
      if (!checkEmpty(blending_variety_etc_list)) {
        blending_variety_list.push(dc.input_direct);
      }
      if (!checkEmpty(blending_process_etc_list)) {
        blending_process_list.push(dc.input_direct);
      }
      const setValues = {
        blending_country_list,
        blending_variety_list,
        blending_grade_list,
        blending_grade_detail_list,
        blending_process_list,
        blending_variety_etc: blending_variety_etc_list.join(","),
        blending_process_etc: blending_process_etc_list.join(","),
      };
      // Debug(setValues);
      form.current.setFieldsValue(setValues);
      runFormFunction(formFunction.current, "blending_variety_list", "checkInputDirect", false);
      runFormFunction(formFunction.current, "blending_process_list", "checkInputDirect", false);
    }
  };

  const addRoastingList = (insertName?: boolean, roasting_result?: boolean) => {
    if (form?.current && formFunction?.current) {
      const roasting_seq = form?.current?.getFieldValue("roasting_seq");
      const roasting_result_year = form?.current?.getFieldValue("roasting_result_year");
      const roasting_result_seq = form?.current?.getFieldValue("roasting_result_seq");
      const roasting_mass = form?.current?.getFieldValue("roasting_mass");
      const roasting_loss = form?.current?.getFieldValue("roasting_loss");
      const roasting_organic_loss = form?.current?.getFieldValue("roasting_organic_loss");
      if (!checkEmpty(roasting_seq) || (!checkEmpty(roasting_result_year) && !checkEmpty(roasting_result_seq))) {
        const { run, result } = runFormFunction(formFunction?.current, "roasting_comb", "getCount");
        const seqList: string[] = [];
        for (let i = 0; i < result; i++) {
          if (roasting_result) {
            seqList.push("roasting_result_seq_" + i);
            seqList.push("roasting_year_seq_" + i);
          } else {
            seqList.push("roasting_seq_" + i);
          }
        }
        const seqValues = form?.current?.getFieldsValue(seqList);

        const checkSeq = roasting_result
          ? getIntArray(result).some((i) => {
              const seq = seqValues["roasting_result_seq_" + i];
              const year = seqValues["roasting_year_seq_" + i];
              return roasting_result_seq === seq && dayjs(year).year() === dayjs(roasting_result_year).year();
            })
          : Object.keys(seqValues).some((item) => {
              return roasting_seq === seqValues[item];
            });

        if (checkSeq) {
          const alertP = alertContext?.setProp;
          if (alertP) {
            alertP({
              open: true,
              title: ta("roasting_add"),
              description: ta("roasting_exist"),
              useCancel: false,
              useOk: true,
              okFunction: () => {
                setTimeout(() => {
                  setRoastingProfileUse();
                }, dc.setTimeoutDelay);
              },
            });
          } else {
            alert(checkSeq);
          }
          return;
        }

        if ((insertName ?? true) && result === 0) {
          const check_values = form?.current?.getFieldsValue(["blending_name_locale", "blending_name"]);
          const check_empty = check_values ? Object.keys(check_values).every((key) => checkEmpty(check_values[key])) : false;
          if (check_empty) {
            const result = runFormFunction(formFunction?.current, "roasting_seq", "selectData");
            // Debug(result.result);
            if (result && result.result) {
              form?.current?.setFieldsValue({
                blending_name_locale: result.result["roasting_name_locale"],
                blending_name: result.result["roasting_name"],
              });
            }
          }
        }

        const setResult: Record<string, any> = {};
        if (roasting_result) {
          setResult["roasting_result_year_" + result] = roasting_result_year;
          setResult["roasting_result_seq_" + result] = roasting_result_seq;
          setResult["roasting_loss_" + result] = roasting_loss;
          setResult["roasting_organic_loss_" + result] = roasting_organic_loss;
        } else {
        }
        setResult["roasting_seq_" + result] = roasting_seq;
        setResult["roasting_mass_" + result] = roasting_mass;
        Debug(setResult);
        runFormFunction(formFunction.current, "roasting_comb", "setCount", result + 1);
        setRoastingOrder();
        if (!roasting_result) {
          setFormValues(form.current, setResult);
          checkSingleOrigin(form.current, "blending_single_origin", result + 1 <= 1);
          calRoastingMass(!(insertName ?? true));
        } else {
          setTimeout(() => {
            Debug("greenbean_year_" + result);
            setFormValues(form.current, setResult);
            setTimeout(() => {
              runFormFunction(formFunction?.current, "roasting_result_seq_" + result, "changeLoad");
              setRoastingInfo();
              calRoastingMass(!(insertName ?? true));
              if (form.current) {
                checkSingleOrigin(form.current, "blending_single_origin", result + 1 <= 1);
              }
            }, dc.setTimeoutDelay / 2);
          }, 150);
        }
      } else {
        Debug(roasting_seq, roasting_result_year, roasting_result_seq);
      }
    }
  };
  const roasting_greenbean: DataColumnField = {
    ...dc.select,
    inputClassName: dc.greenbeanSeqWidth,
    widthFull: true,
    dataUrl: "/api/roaster/roasting/default/code",
    dataProp: {
      load: (data, select_data, name, index) => {
        //Debug(data, select_data, name, index);
        //runFormFunction(formFunction?.current);
      },
    },
    dataLabel: {
      value: "roasting_seq",
      label: [
        params?.locale === enLocale
          ? { field: "roasting_name", subs: "roasting_nick" }
          : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
      ],
      labelSort: true,
    },
    selectPropOption: { reloadButton: false },
    // onChange: (data) => {},
  };

  const checkSingleOrigin = (form: FormInstance, field: string, check: boolean) => {
    if (check) {
      setTimeout(() => {
        const { run, result } = runFormFunction(
          formFunction?.current,
          form.getFieldInstance("roasting_result_seq_0") ? "roasting_result_seq_0" : "roasting_seq_0",
          "selectData",
        );
        if (result && result["roasting_single_origin"] === 1) {
          form.setFieldValue(field, true);
        } else {
          form.setFieldValue(field, false);
        }
        Debug(result);
      }, dc.setTimeoutDelay);
    } else {
      form.setFieldValue(field, check);
    }
  };

  const setBlendingSeq = () => {
    const form_current = form?.current;
    const form_function = formFunction?.current;
    const form_memo = formMemo?.current;
    const { run, result } = runFormFunction(form_function, "blending_seq", "selectData");
    Debug(result);
    if (result && form_current) {
      const value = result["blending_seq"];
      const exField = [
        "blending_seq",
        "blending_country_list",
        "blending_grade_detail_list",
        "blending_grade_list",
        "blending_result_seq_ref",
        "blending_result_year_ref",
        "blending_seq",
        "blending_use",
        "blending_user_seq",
        "blending_variety_list",
        "edit_at",
      ];
      const matching_values = getMatchingData(form_current, form_memo, result, exField);
      form_current.setFieldsValue(matching_values);
      setRoastingProfileUse();
      fetchHost("/api/roaster/blending/default/roasting/" + value, dc.fetchPostOption, props.params?.auth, (data: any) => {
        if (data.result) {
          const setData = data.result;
          runFormFunction(form_function, "roasting_comb", "setCount", data.result.length);
          if (setData instanceof Array) {
            setData.forEach((item) => {
              item["roasting_result_year"] = dayjs(new Date()).year();
            });
          }
          setTimeout(() => {
            const subList = getFormMemo(form_memo, "roasting_comb", "subList");
            const convert = convertSubListToFormDataDetail(
              "roasting_comb",
              subList,
              ["roasting_seq", "roasting_result_year", "roasting_mass", "roasting_percent", "roasting_order"],
              setData,
            );
            const sub_matcing_values = getMatchingData(form_current, form_memo, convert);
            Debug("setBlendingSeq Change :", setData, convert, sub_matcing_values);
            form.current?.setFieldsValue(sub_matcing_values);
            setTimeout(() => {
              getIntArray(setData.length, 0, (i) => {
                runFormFunction(form_function, "roasting_result_seq_" + i, "changeLoad");
              });
            }, dc.setTimeoutShort);
            setTimeout(() => {
              setRoastingOrder();
              setRoastingInfo();
              calRoastingMass(true);
            }, dc.setTimeoutDelay);
          }, dc.setTimeoutDelay);
        }
      });
    } else {
      setRoastingProfileUse();
    }
  };
  const ResultInit = (data: any) => {
    const roasting_seq = form?.current?.getFieldValue("blending_seq");
    const sub_data = data["blending_result_roasting"];
    // Debug(roasting_seq, sub_data);
    if (!checkEmpty(roasting_seq) && checkEmpty(sub_data)) {
      // setTimeout(() => {
      //   setBlendingSeq();
      // }, dc.setTimeoutDelay);
    } else {
    }
  };
  const blending_names: DataCols = {
    blending_name_locale: {
      ...dc.inputFull,
      minLength: params?.locale !== enLocale ? 3 : undefined,
      maxLength: 300,
      showCount: true,
      labelClassName: dc.strongLabelClassName,
      required: params?.locale !== enLocale ? true : undefined,
      read: { variant: "borderless" },
    },
    blending_name: {
      ...dc.inputFull,
      minLength: params?.locale === enLocale ? 3 : undefined,
      maxLength: 300,
      showCount: true,
      labelClassName: dc.strongLabelClassName,
      required: params?.locale === enLocale ? true : undefined,
      read: { variant: "borderless" },
    },

    blending_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true, read: { display: "notNull", variant: "borderless" } },
    blending_nick: { ...dc.inputFull, maxLength: 300, showCount: true, read: { display: "notNull", variant: "borderless" } },
  };

  const blending_public_stage: DataColumnRecord = {
    public_stage_explain: {
      label: "public_stage",
      labelClassName: dc.mobileShow,
      fieldId: {
        public_stage_roaster: {
          ...dc.number,
          placeholder: "public_stage_roaster",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
        public_stage_cafe: {
          ...dc.number,
          placeholder: "public_stage_cafe",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
        public_stage_customer: {
          ...dc.number,
          placeholder: "public_stage_customer",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
        public_stage_normal: {
          ...dc.number,
          placeholder: "public_stage_normal",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
      },
    },
    public_stage: {
      labelClassName: dc.mobileHidden,
      fieldId: {
        public_stage_roaster: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "ALL" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
        public_stage_cafe: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "DTL" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
        public_stage_customer: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "NRML" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
        public_stage_normal: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "LST" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
      },
    },
    blending_auth: {
      ...dc.roasterAuth,
      inputClassName: dc.inputCountryClassName,
      label: "auth_label",
      maxLength: 45,
      showCount: true,
      read: { variant: "borderless", display: "notNull" },
    },
  };

  switch (params?.page.page ?? "") {
    //블렌딩기본 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"blending_default","system_table_pk":["roaster_seq","blending_seq"],"system_table_manual_increment":"blending_seq","system_table_page":"BlendingDefault","system_table_path":"roaster/blending/default","system_table_page_name":"BlendingDefault","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":["blending_auth"],"system_table_mapper":"blending","system_table_detail_result":"blending_result","system_table_search_column":["blending_country_list","blending_grade_list","blending_grade_detail_list","blending_variety_list"],"system_table_search_select":["blending_name_locale","blending_name"],"system_table_order_column":["blending_name_locale","blending_name","blending_nick_locale","blending_nick"],"system_table_default_name_column":"blending_name_locale","system_table_en_name_column":"blending_name","system_table_use_column":"blending_use"}
    //--info--}

    //블렌딩기본로스팅목록
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"blending_default_roasting","system_table_pk":["roaster_seq","blending_seq","roasting_seq"],"system_table_page":"BlendingDefaultRoasting","system_table_path":"roaster/blending/default/roasting","system_table_page_name":"BlendingDefaultRoasting","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":[],"system_table_mapper":"blending","system_table_detail_result":"blending_result"}
    //--info--}

    case "BlendingDefault":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/blending/default/detail/", saveFetch: { fetchUrl: "/api/roaster/blending/default/edit" } },
        listFetch: { fetchUrl: "/api/roaster/blending/default/list" },
        dataResultName: "blending_result",
        dataName: "BlendingDefaultData",
        dataInit: () => {
          calRoastingMass();
        },
        dataCols: {
          blending_seq: { ...dc.hidden },
          ...blending_names,
          // roasting_user_seq: { ...dc.select },
          // roasting_result_year_ref: { ...dc.number },
          // roasting_result_seq_ref: { ...dc.number },
          div_1: dc.itemDiv,
          roasting_comb_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_comb_explain_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_remove_explain: {
                    ...dc.buttonDefault("Minus", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_name_insert_explain: {
                    ...dc.buttonDefault("PencilSimpleLine", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_seq_explain: {
                    ...dc.inputFull,
                    placeholder: "roasting_explain",
                    saveData: false,
                    allowClear: false,
                    inputClassName: "text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
              roasting_comb_explain_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 " + dc.mobileHidden,
                fieldId: {
                  roasting_mass_explain: {
                    ...dc.number,
                    placeholder: "mass",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanMassWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_percent_explain: {
                    ...dc.number,
                    placeholder: "ratio_label",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.inputNumberClassName + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
            },
          },
          roasting_list: {
            labelClassName: dc.mobileHidden,
            read: { itemClassName: "hidden" },
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_list_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_add: {
                    ...dc.buttonDefault(
                      "Plus",
                      () => {
                        addRoastingList();
                      },
                      "default",
                    ),
                    tooltip: "add_label",
                  },
                  roasting_seq: {
                    ...dc.selectSearch,
                    inputClassName: dc.greenbeanSeqWidth,
                    dataUrl: "/api/roaster/roasting/default/code",
                    dataProp: {
                      // load: (data, select_data) => {
                      //   Debug(data, select_data);
                      // },
                    },
                    widthFull: true,
                    dataLabel: {
                      value: "roasting_seq",
                      label: [
                        params?.locale === enLocale
                          ? { field: "roasting_name", subs: "roasting_nick" }
                          : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
                      ],
                      labelSort: true,
                    },
                    selectPropOption: { reloadButtonFront: true },
                    selectWithLoad: seqSelectWithList,
                    onChange: (data) => {},
                    onPressEnter: (e) => {
                      addRoastingList();
                    },
                    tooltip: true,
                    tooltipTransition: false,
                    saveData: false,
                  },
                },
              },
              roasting_list_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  roasting_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    saveData: false,
                    //placeholder: "roasting_mass",
                    onPressEnter: (e) => {
                      addRoastingList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                  roasting_percent: {
                    ...dc.percent,
                    saveData: false,
                    placeholder: "ratio_label",
                    onPressEnter: (e) => {
                      addRoastingList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                },
              },
            },
          },
          div_2: { ...dc.itemDiv, read: { itemClassName: "hidden" } },
          roasting_comb: {
            //labelClassName: "justify-center",
            label: "roasting_count",
            labelMyAuto: false,
            subList: { target: "blending_default_roasting", labelField: "COLUMN_NAME" },
            subListKeys: ["roasting_seq"],
            minLength: 1,
            valueClassName: "flex-col lg:flex-row mobile_multi",

            fieldId: {
              roasting_comb_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_remove: {
                    ...dc.buttonDefault("Minus", undefined, "default"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      //Debug(e);
                      if (form?.current && formFunction?.current) {
                        const result = runSubListCommand(
                          form.current,
                          formFunction.current,
                          "roasting_comb",
                          roasting_fields,
                          e.index,
                          -1,
                          true,
                        );
                        setRoastingOrder();
                        checkSingleOrigin(form.current, "blending_single_origin", result <= 1);
                        setTimeout(() => {
                          setRoastingInfo();
                          calRoastingMass();
                        }, dc.setTimeoutDelay / 2);
                      }
                    },
                    tooltip: "remove_label",
                  },
                  roasting_up: {
                    ...dc.buttonDefault("CaretUp", undefined, "default", undefined, "input_ml px-2 " + dc.mobileHidden),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      if (form?.current && formFunction?.current) {
                        runSubListCommand(form.current, formFunction.current, "roasting_comb", roasting_fields, e.index, e.index - 1);
                        setRoastingOrder();
                      }
                    },
                    tooltip: "up_label",
                  },
                  roasting_name_insert: {
                    ...dc.buttonDefault("PencilSimpleLine", undefined, "default", undefined, "px-2 input_ml"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      const result = runFormFunction(formFunction?.current, "roasting_seq_" + e.index, "selectData");
                      // Debug(result);
                      if (form?.current && result.result) {
                        form.current.setFieldsValue({
                          blending_name_locale: result.result["roasting_name_locale"],
                          blending_name: result.result["roasting_name"],
                          blending_nick_locale: result.result["roasting_nick_locale"],
                          blending_nick: result.result["roasting_nick"],
                        });
                      }
                    },
                    tooltip: "name_insert_label",
                  },

                  roasting_seq: {
                    ...roasting_greenbean,
                    tooltip: true,
                    tooltipTransition: false,
                    tooltipPlacement: "topLeft",
                    selectProp: { suffixIcon: "" },
                    readOnly: true,
                  },
                },
              },
              roasting_comb_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  roasting_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    onChange: (e) => {
                      //Debug(e);
                      calRoastingMass();
                    },
                    //read: { inputClassName: dc.mass.inputClassName + " input-text-center", readOnly: true },
                  },
                  roasting_percent: {
                    ...dc.percent,
                    tooltip: "ratio_label",
                    onChange: (e) => {
                      //Debug(e);
                      //calRoastingMass();
                    },
                  },
                  roasting_order: {
                    ...dc.number,
                    inputClassName: "hidden",
                  },
                },
              },
            },
          },
          blending_total_mass: {
            ...dc.mass,
            inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
            placeholder: "total_mass",
            tooltip: "total_mass",
            tooltipPlacement: "left",
            label: "blank",
            labelClassName: dc.mobileHidden,
            readOnly: true,
            variant: "borderless",
            valueStyle: { justifyContent: "flex-end" },
            //read: { inputClassName: dc.mass.inputClassName + " input-text-center", readOnly: true },
            // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
          },
          ...coffeebeanBestDate,
          blending_single_origin: {
            ...dc.use,
            label: "single_origin_label",
            //disabled: true,
          },
          roasting_instock_change: { ...dc.use, required: true, label: "instock_change_label" },
          blending_create_use: {
            ...dc.use,
            read: { ...dc.use.read, display: "notNull", displayCheckIds: ["roasting_create_seq"] },
          },
          roasting_create_seq: {
            ...dc.selectSearch,
            read: { display: "notNull" },
            inputClassName: "w-full",
            dataUrl: "/api/roaster/roasting/default/code",
            widthFull: true,
            dataLabel: {
              value: "roasting_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "roasting_name", subs: "roasting_nick" }
                  : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
              ],
              labelSort: true,
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            tooltip: true,
            tooltipTransition: false,
            tooltipPlacement: "topLeft",
          },
          // blending_uuid: {
          //   ...dc.qrcode,
          //   linkOption: { pathname: "/user/beannote/beaninfo/" },
          // },
          blending_uuid_str: {
            ...dc.qrcode,
            linkOption: { pathname: "/info/bean/rd/" },
          },
          blending_uuid_cafe: {
            ...dc.qrcode,
            fieldId: "blending_uuid_str",
            label: "cafe_qr_label",
            linkOption: { pathname: "/cafe/coffeebean/qrdefault/" },
          },
          div_3: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["brewing_list", "store_link"] } },
          brewing_list: {
            ...dc.brewingSelect(params?.locale, true),
            read: { display: "notNull" },
            label: "brewing_info",
            dataUrl: "/api/roaster/qc/brewing/default/code",
          },
          store_link: { ...dc.storeLink },
          div_4: dc.itemDiv,
          ...blending_public_stage,
          blending_desc: { ...dc.textAreaDefault, textAreaProp: { rows: 10 }, maxLength: 10000 },
          blending_use: { ...dc.useDefault, required: true },

          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        tempValue: { ...dc.tempPublicStage },
        listColLinkField: "blending_seq",
        listSearch: [
          {
            ...dc.coffee_country,
            inputClassName: dc.searchSelectWidth,
            field: "search0",
            label: "country_label",
            placeholder: "country_label",
          },
          {
            ...dc.grade,
            inputClassName: dc.searchSelectWidth,
            field: "search1",
            label: "grade_label",
            placeholder: "grade_label",
          },
          {
            ...dc.gradeDetail,
            inputClassName: dc.searchSelectWidth,
            field: "search2",
            label: "grade_detail_label",
            placeholder: "grade_detail_label",
          },
          {
            ...dc.variety,
            inputClassName: dc.searchSelectWidth,
            field: "search3",
            label: "variety_label",
            placeholder: "variety_label",
          },
        ],
        listSearchSelect: [
          //{ ...dc.input, field: "search_title_all", label: "blending_name_locale", placeholder: "blending_name_locale" },
          { ...dc.input, field: "blending_name_locale", label: "blending_name_locale", placeholder: "blending_name_locale" },
          { ...dc.input, field: "blending_name", label: "blending_name", placeholder: "blending_name" },
        ],
        listOrder: [
          "blending_name_locale_orderasc",
          "blending_name_locale_orderdesc",
          // "blending_name_orderasc",
          // "blending_name_orderdesc",
          // "blending_nick_locale_orderdesc",
          // "blending_nick_locale_orderasc",
          // "blending_nick_orderdesc",
          // "blending_nick_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "roasting_seq",
          //"roasting_uuid",
          params?.locale === enLocale ? "blending_name" : "blending_name_locale",
          //"roasting_nick",
          //"roasting_nick_locale",
          //"roasting_machine_seq",
          //"roasting_user_seq",
          //"roasting_result_year_ref",
          //"roasting_result_seq_ref",
          //"roasting_single_origin",
          //"roasting_country_list",
          // "roasting_grade_list",
          //"roasting_grade_detail_list",
          // "roasting_variety_list",
          // { field: "blending_total_mass", ...dc.mass, label: "mass" },
          //"roasting_auth"
        ],
      };
    //블렌딩결과 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"blending_result","system_table_pk":["roaster_seq","blending_result_year","blending_result_seq"],"system_table_manual_increment":"blending_result_seq","system_table_page":"BlendingResult","system_table_path":"roaster/blending/result","system_table_page_name":"BlendingResult","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":["blending_auth"],"system_table_mapper":"blending","system_table_detail_result":"blending_result","system_table_search_column":["blending_result_date","blending_country_list","blending_variety_list","blending_process_list"],"system_table_search_select":["blending_name_locale","blending_name","blending_nick_locale","blending_nick"],"system_table_order_column":["blending_result_year","blending_result_date"],"system_table_default_name_column":"blending_name_locale","system_table_en_name_column":"blending_name"}
    //--info--}

    //블렌딩결과로스팅 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"blending_result_roasting","system_table_pk":["roaster_seq","blending_result_year","blending_result_seq","roasting_result_year","roasting_result_seq"],"system_table_page":"BlendingResultRoasting","system_table_path":"roaster/blending/result/roasting","system_table_page_name":"BlendingResultRoasting","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":[],"system_table_mapper":"blending","system_table_detail_result":"blending_result"}
    //--info--}

    case "BlendingResult":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/blending/result/detail/", saveFetch: { fetchUrl: "/api/roaster/blending/result/edit" } },
        listFetch: { fetchUrl: "/api/roaster/blending/result/list" },
        dataResultName: "blending_result",
        dataName: "BlendingResultData",
        checkDataMode: true,
        editReload: true,
        dataCols: {
          blending_seq: {
            label: "blending_select_label",
            ...dc.selectSearch,
            labelClassName: dc.strongLabelClassName,
            inputClassName: "w-full",
            dataUrl: "/api/roaster/blending/default/code",
            dataProp: {
              // load: (data, select_data) => {
              //   setTimeout(() => {
              //     setBlendingSeq();
              //   }, dc.setTimeoutDelay / 2);
              // },
            },
            widthFull: true,
            dataLabel: {
              value: "blending_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "blending_name", subs: "blending_nick" }
                  : { field: "blending_name_locale", subs: "blending_nick_locale" },
              ],
              labelSort: true,
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            onChange: (e) => {
              setBlendingSeq();
            },
            // onPressEnter: (e) => {
            //   //addGreenbeanList(false);
            // },
            tooltip: true,
            tooltipTransition: false,
          },
          ...blending_names,
          blending_result_year: { ...dc.year, update: { disabled: true }, required: true },
          blending_result_seq: dc.hidden,
          blending_result_date: {
            ...dc.date,
            changePass: true,
            update: { disabled: true },
            required: true,

            onChange: (e) => {
              if (form?.current) {
                form.current.setFieldValue("blending_result_year", e.value);
                // form.current.setFieldValue("blending_result_date", e.value);
              }
            },
          },
          ...coffeebeanBestDate,
          blending_instock: {
            ...dc.use,
            label: "instock_label",
            labelClassName: dc.strongLabelClassName,
          },
          div_1: dc.itemDiv,
          roasting_comb_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_comb_explain_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_remove_explain: {
                    ...dc.buttonDefault("Minus", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_name_insert_explain: {
                    ...dc.buttonDefault("PencilSimpleLine", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_seq_explain: {
                    ...dc.inputFull,
                    placeholder: "roasting_explain",
                    saveData: false,
                    allowClear: false,
                    inputClassName: "text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
              roasting_comb_explain_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 " + dc.mobileHidden,
                fieldId: {
                  roasting_year_explain: {
                    ...dc.number,
                    placeholder: "roasting_year",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.selectYearWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_mass_explain: {
                    ...dc.number,
                    label: "mass",
                    placeholder: "mass",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanMassWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_percent_explain: {
                    ...dc.number,
                    placeholder: "ratio_label",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanNumberWidth + " input-text-center" + roasting_comb_hidden,
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_loss_explain: {
                    ...dc.number,
                    placeholder: "loss_rate",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanNumberWidth + " input-text-center" + roasting_comb_hidden,
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_organic_loss_explain: {
                    ...dc.number,
                    placeholder: "organic_loss",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanNumberWidth + " input-text-center" + roasting_comb_hidden,
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
            },
          },
          roasting_list: {
            labelClassName: dc.mobileHidden,
            read: { itemClassName: "hidden" },
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_list_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_add: {
                    ...dc.buttonDefault(
                      "Plus",
                      () => {
                        addRoastingList(false, true);
                      },
                      "default",
                    ),
                    tooltip: "add_label",
                  },
                  roasting_reload: {
                    ...dc.buttonDefault(
                      "ArrowClockwise",
                      () => {
                        runFormFunction(formFunction?.current, "roasting_result_seq", "reload", true);
                        //runFormFunction(formFunction?.current, "roasting_result_year", "reload", true);
                      },
                      "default",
                      undefined,
                      "px-2 input_ml",
                    ),
                    tooltip: "reload_label",
                  },
                  roasting_result_seq: {
                    ...dc.selectSearch,
                    inputClassName: dc.greenbeanSeqWidth,
                    //dataUrl: "/api/roaster/roasting/result/code",
                    create: { dataUrl: "/api/roaster/roasting/result/code", dataProp: { firstReload: true } },
                    dataValueList: ["roasting_instock_list"],
                    // dataProp: {
                    //   load: (data, select_data) => {
                    //     Debug(data, select_data);
                    //   },
                    // },
                    widthFull: true,
                    dataLabel: {
                      value: "roasting_result_seq",
                      label: [
                        "roasting_result_date",
                        "roasting_batch_no",
                        params?.locale === enLocale
                          ? { field: "roasting_name", subs: "roasting_nick" }
                          : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
                      ],
                      labelSort: true,
                    },
                    selectPropOption: { reloadButton: false },
                    //selectWithLoad: resultSelectWithList,
                    //selectChangeLoad: "roasting_greenbean_year",
                    selectFieldFilter: { roasting_result_year: "roasting_result_year" },
                    selectFieldRequired: "roasting_result_year",

                    onChange: (data) => {
                      const temp_result = runFormFunction(formFunction?.current, "roasting_result_seq", "selectData");
                      const convert_values = convertFormValues(formMemo?.current, temp_result.result, [
                        "roasting_mass",
                        "roasting_loss",
                        "roasting_organic_loss",
                      ]);
                      if (convert_values) {
                        form?.current?.setFieldsValue(convert_values);
                      }
                    },
                    onPressEnter: (e) => {
                      addRoastingList(false, true);
                    },
                    tooltip: true,
                    tooltipTransition: false,
                    saveData: false,
                  },
                },
              },
              roasting_list_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  // roasting_year: {
                  //   ...dc.select,
                  //   inputClassName: dc.selectYearWidth + " input-text-center",
                  //   dataUrl: "/api/roaster/roasting/year/code",
                  //   dataProp: {
                  //     load: (data, select_data, field, index, change) => {
                  //       //Debug(data, select_data);
                  //       if (form?.current) {
                  //         const moisture = getMoistureAvg(select_data);
                  //         if (moisture) {
                  //           form.current.setFieldValue("roasting_moisture", moisture);
                  //         }
                  //       }
                  //     },
                  //   },
                  //   dataLabel: {
                  //     value: "roasting_result_year",
                  //     label: ["roasting_result_year"],
                  //     labelSort: -1,
                  //   },
                  //   selectFieldFilter: { greenbean_roaster_seq: "roasting_greenbean_seq" },
                  //   selectFieldRequired: "roasting_greenbean_seq",
                  //   selectPropOption: { reloadButton: false, setEmptyValue: 0 },
                  //   selectWithLoad: yearSelectWithList,
                  //   onChange: (data) => {
                  //     const temp_result = runFormFunction(formFunction?.current, "roasting_year", "selectData");
                  //     if (form?.current && temp_result.result) {
                  //       const moisture = getMoistureAvg(temp_result.result);
                  //       if (moisture) {
                  //         form.current.setFieldValue("roasting_moisture", moisture);
                  //       }
                  //     }
                  //   },
                  //   // onPressEnter: (e) => {
                  //   //   addGreenbeanList(false);
                  //   // },
                  //   placeholder: "year_select",
                  //   saveData: false,
                  // },
                  roasting_result_year: {
                    ...dc.year,
                    inputClassName: dc.selectYearWidth,
                    saveData: false,
                    dateProp: { nowButton: false },

                    placeholder: "year_select",
                    onChange: (e) => {
                      Debug(e);
                      runFormFunction(formFunction?.current, "roasting_result_seq", "changeLoad");
                    },
                  },
                  roasting_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    saveData: false,
                    //placeholder: "roasting_mass",
                    onPressEnter: (e) => {
                      addRoastingList(false);
                    },

                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                  roasting_percent: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName + roasting_comb_hidden,
                    saveData: false,
                    placeholder: "ratio_label",
                    onPressEnter: (e) => {
                      addRoastingList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                  roasting_loss: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName + roasting_comb_hidden,
                    saveData: false,
                    placeholder: "loss_rate",
                    onPressEnter: (e) => {
                      addRoastingList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                  roasting_organic_loss: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName + roasting_comb_hidden,
                    saveData: false,
                    placeholder: "organic_loss",
                    onPressEnter: (e) => {
                      addRoastingList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                },
              },
            },
          },
          div_2: { ...dc.itemDiv, read: { itemClassName: "hidden" } },
          roasting_comb: {
            label: "roasting_count",
            subList: { target: "blending_result_roasting", labelField: "COLUMN_NAME", valueConvert: false },
            subListKeys: ["roasting_result_year", "roasting_result_seq"],
            minLength: 1,

            labelClassName: dc.mobileHidden,
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_comb_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_remove: {
                    ...dc.buttonDefault("Minus", undefined, "default"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      //Debug(e);
                      if (form?.current && formFunction?.current) {
                        const result = runSubListCommand(
                          form.current,
                          formFunction.current,
                          "roasting_comb",
                          roasting_result_fields,
                          e.index,
                          -1,
                          true,
                        );
                        calRoastingMass(true);
                        setRoastingOrder();
                        checkSingleOrigin(form.current, "roasting_single_origin", result <= 1);
                        setTimeout(() => {
                          setRoastingInfo();
                        }, dc.setTimeoutDelay / 2);
                      }
                    },
                    tooltip: "remove_label",
                  },
                  roasting_up: {
                    ...dc.buttonDefault("CaretUp", undefined, "default", undefined, "input_ml px-2 " + dc.mobileHidden),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      if (form?.current && formFunction?.current) {
                        runSubListCommand(
                          form.current,
                          formFunction.current,
                          "roasting_greenbean_comb",
                          roasting_result_fields,
                          e.index,
                          e.index - 1,
                        );
                        setRoastingOrder();
                      }
                    },
                    tooltip: "up_label",
                  },

                  roasting_result_seq: {
                    ...dc.selectSearch,
                    inputClassName: dc.greenbeanSeqWidth,
                    required: true,
                    //dataUrl: "/api/roaster/roasting/result/code",
                    create: { dataUrl: "/api/roaster/roasting/result/code" },
                    dataValueList: ["blending_result_roasting", "roasting_instock_list"],
                    onChange: (e) => {
                      const index = e.index;
                      const temp_result = runFormFunction(formFunction?.current, "roasting_result_seq_" + index, "selectData");
                      const select_data = temp_result.result;
                      const set_values: Record<string, any> = {};
                      const set_fields = ["roasting_mass", "roasting_loss", "roasting_organic_loss"];
                      set_fields.forEach((field) => {
                        if (select_data) {
                          set_values[field + "_" + index] = select_data[field];
                        } else {
                          set_values[field + "_" + index] = undefined;
                        }
                      });
                      if (!select_data) {
                        set_values["roasting_result_seq_" + index] = undefined;
                      }
                      if (!checkEmpty(set_values)) {
                        const convert_values = convertFormValues(formMemo?.current, set_values);
                        form?.current?.setFieldsValue(convert_values);
                        setRoastingInfo();
                        calRoastingMass();
                      }
                    },
                    dataProp: {
                      load: (data, select_data, field, index) => {
                        const set_values: Record<string, any> = {};
                        const set_fields = ["roasting_mass", "roasting_loss", "roasting_organic_loss"];
                        set_fields.forEach((field) => {
                          if (select_data) {
                            set_values[field + "_" + index] = select_data[field];
                          } else {
                            set_values[field + "_" + index] = undefined;
                          }
                        });
                        if (!select_data) {
                          //set_values["roasting_result_seq_" + index] = undefined;
                        }
                        if (!checkEmpty(set_values)) {
                          const convert_values = convertFormValues(formMemo?.current, set_values);
                          Debug("roasting_result_seq " + index, data, select_data, index, convert_values);
                          setTimeout(() => {
                            form?.current?.setFieldsValue(convert_values);
                            setRoastingInfo();
                            calRoastingMass();
                          }, dc.setTimeoutDelay);
                        }
                      },
                    },
                    widthFull: true,
                    dataLabel: {
                      value: "roasting_result_seq",
                      label: [
                        "roasting_result_date",
                        "roasting_batch_no",
                        params?.locale === enLocale
                          ? { field: "roasting_name", subs: "roasting_nick" }
                          : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
                      ],
                      labelSort: true,
                    },
                    selectPropOption: { reloadButton: false, setEmptyValue: 0 },
                    //selectWithLoad: seqSelectWithList,
                    //selectChangeLoad: "roasting_greenbean_year",
                    selectFieldFilter: { roasting_result_year: "roasting_result_year", roasting_seq: "roasting_seq" },
                    selectFieldRequired: "roasting_result_year",
                  },
                },
              },
              roasting_comb_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  roasting_result_year: {
                    ...dc.year,
                    inputClassName: dc.selectYearWidth,
                    dateProp: { nowButton: false },
                    required: true,
                    onChange: (e) => {
                      Debug("roasting_comb_sub", e);
                      runFormFunction(formFunction?.current, "roasting_result_seq_" + e.index, "changeLoad");
                    },
                  },
                  roasting_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    onChange: (e) => {
                      //Debug(e);
                      calRoastingMass(true);
                    },
                    //read: { inputClassName: dc.mass.inputClassName + " input-text-center", readOnly: true },
                  },
                  roasting_seq: {
                    ...dc.number,
                    saveData: false,
                    inputClassName: dc.selectYearWidth + roasting_comb_hidden,
                  },
                  roasting_percent: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName + roasting_comb_hidden,
                    tooltip: "ratio_label",
                    onChange: (e) => {
                      //Debug(e);
                      //calRoastingMass(true);
                    },
                  },
                  roasting_loss: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName + roasting_comb_hidden,
                    tooltip: "loss_rate",
                    onChange: (e) => {
                      //Debug(e);
                      //calRoastingMass(true);
                    },
                  },
                  roasting_organic_loss: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName + roasting_comb_hidden,
                    tooltip: "organic_loss",
                    onChange: (e) => {
                      //Debug(e);
                      //calRoastingMass(true);
                    },
                  },
                  roasting_order: {
                    ...dc.number,
                    inputClassName: "hidden",
                  },
                },
              },
            },
          },
          div_3: dc.itemDiv,
          blending_country_list: {
            ...dc.coffee_country,
            label: "country_label",
            inputType: "selectSearch",
            selectProp: { mode: "multiple" },
          },
          blending_grade_list: { ...dc.grade, selectProp: { mode: "multiple" } },
          blending_grade_detail_list: { ...dc.gradeDetail, selectProp: { mode: "multiple" } },
          blending_variety_list: {
            ...dc.varietyMulti,
            selectProp: { mode: "multiple" },
            inputDirect: { target: "blending_variety_etc", query: ".blending_variety_etc_item" },
            read: {
              onClick: dc.clickDefault(
                (e: any) => {
                  //alert(e);
                },
                () => {
                  //alert("해당 품종에 대한 정보가 없습니다.");
                },
              ),
            },
          },
          blending_variety_etc: {
            ...dc.inputFull,
            itemClassName: "blending_variety_etc_item",
            minLength: 3,
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "blending_variety_list",
          },
          blending_process_list: {
            ...dc.process,
            label: "process_label",
            selectProp: { mode: "multiple" },
            inputDirect: { target: "blending_process_etc", query: ".blending_process_etc_item" },
          },
          blending_process_etc: {
            ...dc.inputFull,
            itemClassName: "blending_process_etc_item",
            minLength: 3,
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "process_label",
          },
          blending_single_origin: {
            ...dc.use,
            changePass: true,
            label: "single_origin_label",
            //disabled: true,
          },
          div_4: dc.itemDiv,

          status_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            fieldId: {
              explain_mass: {
                ...dc.mass,
                inputClassName: dc.inputNumberClassName,
                readOnly: true,
                disabled: true,
                variant: "borderless",
              },
              explain_loss: {
                ...dc.percent,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                placeholder: "loss_rate",
                read: { display: "notNull", displayCheckIds: ["blending_loss"] },
              },
              explain_organic_loss: {
                ...dc.percent,
                inputClassName: "w-[8rem] text-last",
                readOnly: true,
                disabled: true,
                variant: "borderless",
                placeholder: "organic_loss",
                read: { display: "notNull", displayCheckIds: ["blending_organic_loss"] },
              },
            },
          },

          blending_calc: {
            labelClassName: dc.strongLabelClassName,
            fieldId: {
              blending_total_mass: {
                ...dc.mass,
                inputClassName: dc.inputNumberClassName,
                disabled: true,
                readOnly: true,
                variant: "borderless",
              },
              blending_loss: { ...dc.lossRate, tooltip: "loss_rate" }, //, variant: "borderless"
              blending_organic_loss: {
                ...dc.lossRate,
                inputClassName: "w-[8rem] text-last",
                placeholder: "organic_loss",
                tooltip: "organic_loss",
                read: { display: "notNull" },
              }, //, variant: "borderless"
            },
          },
          roasting_instock_change: { ...dc.use, required: true, label: "instock_change_label", read: { display: false } },
          div_5: dc.itemDiv,
          ...blending_public_stage,
          // blending_result_uuid: {
          //   ...dc.qrcode,
          //   linkOption: { pathname: "/user/beannote/beandetail/" },
          // },
          blending_result_uuid_str: {
            ...dc.qrcode,
            linkOption: { pathname: "/info/bean/rt/" },
          },
          blending_result_uuid_cafe: {
            ...dc.qrcode,
            fieldId: "blending_result_uuid_str",
            label: "cafe_qr_label",
            linkOption: { pathname: "/cafe/coffeebean/qrreceived/" },
          },
          blending_create_use: {
            ...dc.use,
            read: { ...dc.use.read, display: "notNull", displayCheckIds: ["roasting_create_seq"] },
          },
          roasting_create_seq: {
            ...dc.selectSearch,
            read: { display: "notNull" },
            changePass: true,
            inputClassName: "w-full",
            dataValueList: "roasting_default_list",
            edit: {
              dataUrl: "/api/roaster/roasting/default/code",
            },
            widthFull: true,
            dataLabel: {
              value: "roasting_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "roasting_name", subs: "roasting_nick" }
                  : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
              ],
              labelSort: true,
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            tooltip: true,
            tooltipTransition: false,
            tooltipPlacement: "topLeft",
          },
          // roasting_result_detail: dc.input,
          //blending_result_memo: { ...dc.textArea, textAreaProp: { rows: 10 }, maxLength: 3000 },
          brewing_list: {
            ...dc.brewingSelect(params?.locale, true),
            read: { display: "notNull" },
            label: "brewing_info",
            dataUrl: "/api/roaster/qc/brewing/default/code",
          },
          blending_result_desc: { ...dc.textAreaMDefault, maxLength: 5000 },
          rgst_info: dc.rgst,
          edit_info: dc.edit,
        },
        tempValue: { ...dc.tempPublicStage },
        listEdit: {
          field: "blending_instock",
          button: {
            onClick: (chageValues: any[] | undefined) => {
              listEditClickCommon(
                t,
                ta,
                dataFunction?.current,
                alertContext,
                "/api/roaster/blending/result/instock/update",
                params?.auth,
                "instock_list",
                chageValues,
              );
            },
          },
        },

        listColLinkField: ["blending_result_year", "blending_result_seq"],
        listSearch: [
          {
            ...dc.date,
            field: "search0",
            label: "blending_result_date",
            placeholder: "blending_result_date",
          },
          {
            ...dc.coffee_country,
            inputClassName: dc.searchSelectWidth,
            field: "search1",
            label: "country_label",
            placeholder: "country_label",
          },
          {
            ...dc.variety,
            inputClassName: dc.searchSelectWidth,
            field: "search2",
            label: "variety_label",
            placeholder: "variety_label",
          },
          {
            ...dc.process,
            inputClassName: dc.searchSelectWidth,
            field: "search3",
            label: "process_label",
            placeholder: "process_label",
          },
        ],

        listSearchSelect: [
          // { ...dc.input, field: "search_title_all", label: "blending_name_locale", placeholder: "blending_name_locale" },
          { ...dc.input, field: "blending_name_locale", label: "blending_name_locale", placeholder: "blending_name_locale" },
          // { ...dc.input, field: "search_type1", label: "blending_name", placeholder: "blending_name" },
          { ...dc.input, field: "blending_nick_locale", label: "blending_nick_locale", placeholder: "blending_nick_locale" },
          // { ...dc.input, field: "search_type3", label: "blending_nick", placeholder: "blending_nick" },
        ],
        listOrder: [
          // "blending_result_year_orderdesc",
          // "blending_result_year_orderasc",
          "blending_name_locale_orderdesc",
          "blending_name_locale_orderasc",
          "blending_result_date_orderdesc",
          "blending_result_date_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "blending_result_year",
          // "blending_result_seq",
          //"blending_uuid",
          "blending_result_date",
          //"blending_seq",
          params?.locale === enLocale ? "blending_name" : "blending_name_locale",
          //"blending_nick",
          //"blending_nick_locale",
          //"blending_single_origin",
          // "blending_country_list",
          // "blending_variety_list",
          //"blending_variety_etc",
          // "blending_process_list",
          //"blending_process_etc",
          //"blending_grade_list",
          //"blending_grade_detail_list",
          //"blending_total_mass",
          //"blending_moisture",
          //"blending_agtron",
          { field: "blending_total_mass", ...dc.mass },
          { field: "blending_loss", ...dc.percent, label: "loss_rate" },
          // { field: "blending_organic_loss", ...dc.percent, label: "organic_loss" },
          //"blending_result_detail",
          //"blending_result_memo",
          { ...dc.listUse, field: "blending_instock", label: "instock_label" },
          //"blending_auth",
          //"public_stage_roaster",
          //"public_stage_cafe",
          //"public_stage_customer",
          //"public_stage_normal"
        ],
        listColMobileTitle: params?.locale === enLocale ? "blending_name" : "blending_name_locale",
      };
    case "BlendingInventory":
    default:
      return undefined;
  }
};
